import { useEffect, useState } from 'react';
import axios from '../axios-default';
import { useDispatch } from 'react-redux';
import { easySnackbar } from '../store/Noti/noti.actions';

export const initialRetainerRequest = {
    caseId: 0,
    impressionType: '',
    upperFixedWire: false,
    upperRetainerTypeId: null,
    upperBleachingRetainersSelect: '',
    // upperFixedPalatalWireSelect: '',
    upperWireSelect: '',
    upperClearRetainerDesignUpperOption: '',
    upperClearRetainerDesignLowerOption: '',
    upperClearRetainerDesignUpperOptionForSecondSet: '',
    upperClearRetainerDesignLowerOptionForSecondSet: '',
    upperPontics: null, // number[] | null
    upperBiteRamp: null, // number[] | null

    upperPontic: null, // string | null
    upperPonticColor: null, // string | null
    upperLowTrimlineAreaSelect_3: '',  
    upperLowTrimlineAreaSelect_1: '',
    lowerLowTrimlineAreaSelect_3: '',
    lowerLowTrimlineAreaSelect_1: '',
    lowerFixedWire: false,
    lowerRetainerTypeId: null,
    lowerBleachingRetainersSelect: '',
    // lowerFixedPalatalWireSelect: '',
    lowerWireSelect: '',
    lowerClearRetainerDesignUpperOption: '',
    lowerClearRetainerDesignLowerOption: '',
    lowerClearRetainerDesignUpperOptionForSecondSet: '',
    lowerClearRetainerDesignLowerOptionForSecondSet: '',
    lowerPontics: null, // number[] | null
    lowerBiteRamp: null, // number[] | null

    lowerPontic: null, // string | null
    lowerPonticColor: null, // string | null

    specialInstruction: '',
    createdBy: 0,

    caseImpression: {
        case_id: 0,
        case_impression_id: 0,
        type: undefined,
        stl_file0: '',
        stl_file1: '',
        stl_file2: '',
        stl_file3: '',
        stl_files_later: false,
        refinement_no: 0,
        courier_company: '',
        doctor_id: '',
        modern_code: '',
        scanner_brand: '',
        waybill_number: '',
    },
};

export const RETAINER_REQUEST_STATUS = {
    // Request started
    RETAINER_REQUEST_REQ: 'RETAINER_REQUEST_REQ',
    // Production in Progress
    RETAINER_REQUEST_PRO: 'RETAINER_REQUEST_PRO',
    // Delivered
    RETAINER_REQUEST_DEL: 'RETAINER_REQUEST_DEL',
};

export const RETAINER_REQUEST_REMOVE_STAGE = {
    REQUEST: 'REQUEST',
    PRODUCTION: 'PRODUCTION',
    DELIVERED: 'DELIVERED',
};

const useRetainerRequest = ({ retainerRequestId = 0 }) => {
    const [loading, setLoading] = useState(false);
    const [retainerRequest, setRetainerRequest] = useState(initialRetainerRequest);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchRetainerRequest = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`case/retainerRequest/${retainerRequestId}`);
                if (res.data && res.status === 200 && res.data.retainerRequest) {
                    setRetainerRequest(res.data.retainerRequest);
                }
            } catch (error) {
                dispatch(easySnackbar('error', error.message));
            } finally {
                setLoading(false);
            }
        };
        if (retainerRequestId) {
            fetchRetainerRequest();
        }
    }, [retainerRequestId, dispatch, easySnackbar]);

    return {
        loading,
        retainerRequest,
        setRetainerRequest,
    };
};

export default useRetainerRequest;
